@if (title) {
<div class="-menu-navigator">
  <app-link class="-title" (click)="closeMenu()">
    <span class="-icon-container"><icon icon="l_left_ankle"></icon></span>{{ title }}</app-link
  >
</div>
}
<div class="-menu-category" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="-left-column">
    <div class="-default-category-menus">
      @for (category of products; track category; let index = $index; let isFirst = $first) {
      <div
        class="-default-category-menu"
        [ngClass]="{ '-active-first': isFirst, '-active': activeCategory === index }"
        (mouseenter)="activeCategory = index">
        <app-link>{{ category.title }}</app-link>
        <div class="-menu-items-mobile">
          @for (item of category.children; track item) {
          <app-link [to]="item.path">
            <menu-item-card
              [name]="item.title"
              [description]="item.description"
              [icon]="item.icon"
              [indicator]="item.indicator"></menu-item-card>
          </app-link>
          }
        </div>
      </div>
      }
    </div>
    @if (specialMenuPath && specialMenuTitle) {
    <div class="-special-category-menu">
      <app-link [to]="specialMenuPath">{{ specialMenuTitle }}</app-link>
    </div>
    }
  </div>
  <div class="-right-column">
    @for (category of products; track category; let index = $index; let isFirst = $first) {
    <div
      class="-menu-items-container"
      [ngClass]="{ '-active-first': isFirst && activeCategory === null, '-active': activeCategory === index }">
      @for (item of category.children; track item) {
      <app-link [to]="item.path">
        <menu-item-card
          [name]="item.title"
          [description]="item.description"
          [icon]="item.icon"
          [indicator]="item.indicator"></menu-item-card>
      </app-link>
      }
    </div>
    }
  </div>
</div>
